module.exports = __webpack_public_path__ + "static/media/01n.03f0e65b.png";